(() => {
  const initCarousel = (carousel) => {
    if (carousel.dataset.homeCarouselReady === 'true') return;
    carousel.dataset.homeCarouselReady = 'true';
    const slides = [...carousel.querySelectorAll('[data-home-carousel-slide]')];
    const controls = carousel.querySelector('[data-home-carousel-controls]');
    const previous = carousel.querySelector('[data-home-carousel-previous]');
    const next = carousel.querySelector('[data-home-carousel-next]');
    const pause = carousel.querySelector('[data-home-carousel-pause]');
    const pauseLabel = carousel.querySelector('[data-home-carousel-pause-label]');
    const status = carousel.querySelector('[data-home-carousel-status]');
    const dots = carousel.querySelector('[data-home-carousel-dots]');
    if (!slides.length || !controls || !previous || !next || !pause || !dots) return;

    let current = Math.max(0, slides.findIndex((slide) => !slide.hidden));
    let timer = null;
    let explicitPaused = false;
    let interactionPaused = false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplayRequested = carousel.dataset.autoplay === 'true';

    const dotButtons = slides.map((slide, index) => {
      if (!slide.id) slide.id = `HomeSlide-${index + 1}`;
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `Show promotion ${index + 1}`);
      button.setAttribute('aria-controls', slide.id);
      button.addEventListener('click', () => show(index, true));
      dots.append(button);
      return button;
    });

    const stopTimer = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };
    const canAutoplay = () => autoplayRequested && slides.length > 1 && !reduceMotion.matches && !explicitPaused && !interactionPaused;
    const startTimer = () => {
      stopTimer();
      if (canAutoplay()) timer = window.setInterval(() => show(current + 1, false), 3000);
    };
    const updatePause = () => {
      pause.setAttribute('aria-pressed', explicitPaused ? 'true' : 'false');
      if (pauseLabel) pauseLabel.textContent = explicitPaused ? 'Play' : 'Pause';
      pause.disabled = slides.length < 2 || reduceMotion.matches;
    };
    function show(index, announce) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dotButtons.forEach((button, dotIndex) => button.setAttribute('aria-current', dotIndex === current ? 'true' : 'false'));
      if (announce && status) status.textContent = `Promotion ${current + 1} of ${slides.length}`;
      slides.forEach((slide, slideIndex) => {
        const video = slide.querySelector('[data-home-hero-video]');
        if (!video) return;
        if (slideIndex === current && !reduceMotion.matches) void video.play().catch(() => undefined);
        else video.pause();
      });
      startTimer();
    }

    previous.addEventListener('click', () => show(current - 1, true));
    next.addEventListener('click', () => show(current + 1, true));
    pause.addEventListener('click', () => {
      explicitPaused = !explicitPaused;
      updatePause();
      startTimer();
    });
    carousel.addEventListener('focusin', () => { interactionPaused = true; stopTimer(); });
    carousel.addEventListener('focusout', (event) => {
      if (carousel.contains(event.relatedTarget)) return;
      interactionPaused = false;
      startTimer();
    });
    carousel.addEventListener('keydown', (event) => {
      interactionPaused = true;
      stopTimer();
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1, true); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1, true); }
    });
    reduceMotion.addEventListener?.('change', () => { updatePause(); startTimer(); });
    previous.disabled = slides.length < 2;
    next.disabled = slides.length < 2;
    controls.hidden = false;
    updatePause();
    show(current, false);
    const loadVideos = () => {
      if (reduceMotion.matches) return;
      slides.forEach((slide) => {
        const video = slide.querySelector('[data-home-hero-video]');
        const source = video?.querySelector('source[data-src]');
        if (!video || !source?.dataset.src || source.src) return;
        source.src = source.dataset.src;
        video.load();
        video.addEventListener('canplay', () => {
          slide.classList.add('is-video-ready');
          if (!slide.hidden) void video.play().catch(() => undefined);
        }, { once: true });
      });
    };
    requestAnimationFrame(() => window.setTimeout(loadVideos, 0));
  };

  const initFinder = (form) => {
    if (form.dataset.homeVehicleReady === 'true') return;
    form.dataset.homeVehicleReady = 'true';

    const make = form.querySelector('[data-home-vehicle-make]');
    const model = form.querySelector('[data-home-vehicle-model]');
    const year = form.querySelector('[data-home-vehicle-year]');
    const submit = form.querySelector('[data-home-vehicle-submit]');
    const status = form.querySelector('[data-home-vehicle-status]');
    const dataNode = form.querySelector('[data-home-vehicle-data]');
    let options = [];
    try {
      const parsed = JSON.parse(dataNode?.textContent || '[]');
      options = Array.isArray(parsed) ? parsed.filter((item) => item && item.make && item.model && item.url && Array.isArray(item.years) && item.years.length) : [];
    } catch (_error) {
      options = [];
    }

    const replaceOptions = (select, placeholder, values) => {
      if (!select) return;
      select.replaceChildren(new Option(placeholder, ''));
      values.forEach((entry) => select.add(new Option(entry.label, entry.value)));
    };
    const makes = [...new Set(options.map((item) => String(item.make)))];
    replaceOptions(make, makes.length ? 'Choose make' : 'Vehicle options unavailable', makes.map((value) => ({ label: value, value })));
    if (make) make.disabled = !makes.length;

    const updateSubmit = () => {
      if (submit) submit.disabled = !(make?.value && model?.value && year?.value);
    };
    const updateModels = () => {
      const selectedMake = make?.value || '';
      const models = options.filter((item) => item.make === selectedMake);
      replaceOptions(model, selectedMake ? 'Choose model' : 'Choose make first', models.map((item) => ({ label: item.model, value: item.id })));
      model.disabled = !selectedMake || !models.length;
      replaceOptions(year, 'Choose model first', []);
      year.disabled = true;
      updateSubmit();
    };
    const updateYears = () => {
      const selected = options.find((item) => item.id === model?.value && item.make === make?.value);
      const years = selected ? [...new Set(selected.years.map(Number))].filter(Number.isInteger).sort((left, right) => right - left) : [];
      replaceOptions(year, selected ? 'Choose year' : 'Choose model first', years.map((value) => ({ label: String(value), value: String(value) })));
      year.disabled = !selected || !years.length;
      updateSubmit();
    };

    make?.addEventListener('change', updateModels);
    model?.addEventListener('change', updateYears);
    year?.addEventListener('change', updateSubmit);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const selected = options.find((item) => item.id === model?.value && item.make === make?.value && item.years.map(String).includes(year?.value || ''));
      if (!selected || !/^\d{4}$/.test(year?.value || '')) {
        if (status) status.textContent = 'Choose a make, model, and year.';
        return;
      }

      const context = {
        applicationId: Array.isArray(selected.applicationIdsByYear?.[year.value]) && selected.applicationIdsByYear[year.value].length === 1 ? String(selected.applicationIdsByYear[year.value][0]) : '',
        year: year.value.trim(),
        make: make.value.trim(),
        model: String(selected.model),
        platform: String(selected.model),
        expiresAt: Date.now() + (30 * 60 * 1000)
      };
      try {
        sessionStorage.setItem('avid:vehicle-context', JSON.stringify(context));
      } catch (_error) {
        // URL-carried context remains available when storage is restricted.
      }

      const destination = new URL(selected.url, window.location.origin);
      if (context.applicationId) destination.searchParams.set('vehicle_application_id', context.applicationId);
      destination.searchParams.set('vehicle_year', context.year);
      destination.searchParams.set('vehicle_make', context.make);
      destination.searchParams.set('vehicle_model', context.model);
      destination.searchParams.set('vehicle_platform', context.platform);
      window.location.assign(`${destination.pathname}${destination.search}`);
    });

    if (!options.length && status) status.textContent = 'No matching vehicle-year selection is currently available. Use Shop by Vehicle or contact AVID for help.';
    updateModels();
  };

  const initCountdown = (banner) => {
    if (banner.dataset.countdownReady === 'true') return;
    banner.dataset.countdownReady = 'true';
    const end = Date.parse(banner.dataset.saleEnd || '');
    const label = banner.querySelector('[data-sale-countdown-label]');
    const value = banner.querySelector('[data-sale-countdown-value]');
    if (!Number.isFinite(end) || !label || !value) { banner.hidden = true; return; }
    let timer;
    const tick = () => {
      const now = Date.now();
      if (now >= end) {
        label.textContent = 'The Sand Show sale has ended.';
        value.textContent = '';
        const carousel = banner.previousElementSibling;
        if (carousel?.matches('[data-home-carousel]')) carousel.hidden = true;
        const announcement = document.querySelector('.sf-event-announcement');
        if (announcement) announcement.hidden = true;
        if (timer) window.clearInterval(timer);
        return;
      }
      label.textContent = 'Sale ends in';
      const remaining = Math.max(0, Math.ceil((end - now) / 1000));
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(remaining % 86400 / 3600);
      const minutes = Math.floor(remaining % 3600 / 60);
      const seconds = remaining % 60;
      value.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
    };
    tick();
    if (Date.now() < end) timer = window.setInterval(tick, 1000);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('[data-sale-countdown]').forEach(initCountdown);
    if (scope.matches?.('[data-home-carousel]')) initCarousel(scope);
    scope.querySelectorAll?.('[data-home-carousel]').forEach(initCarousel);
    if (scope.matches?.('[data-home-vehicle-finder]')) initFinder(scope);
    scope.querySelectorAll?.('[data-home-vehicle-finder]').forEach(initFinder);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
